export enum SobreNosSubPageEnum {
  História = 1,
  Identidade = 2,
  Diretores = 3,
  Unidades = 4
}

export type SobreNosNavigateState = {
  initialSobreNosSubPage?: SobreNosSubPageEnum;
};